<script setup lang="ts">
import loadingGif from '@/assets/images/loading.gif'
</script>
<template>
    <div class="root-box">
      <div class="spinner">
        <img :src="loadingGif"/>
      </div>
    </div>
</template>

<style lang="scss">
.root-box {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner{
  width: 120px;
}
</style>